import { Loader } from "@googlemaps/js-api-loader";

(function () {
  'use strict';

  const mapContainer = document.querySelector('.js-microsite-map');

  let micrositeMap = {
    initialize: async function () {
      const loader = new Loader({
        apiKey: apiKey,
        version: "weekly",
      });

      const [{Map}, {Marker}] = await Promise.all([
        loader.importLibrary('maps'),
        loader.importLibrary('marker')
      ]);

      let map = new Map(
        mapContainer,
        {
          center: {
            lat: parseFloat(micrositeLat),
            lng: parseFloat(micrositeLng)
          },
          zoom: 16,
          mapId: '1714658323',
          disableDefaultUI: true,
        }
      );

      new google.maps.marker.AdvancedMarkerElement({
        position: {
          lat: parseFloat(micrositeLat),
          lng: parseFloat(micrositeLng)
        },
        map,
      });
    }
  }

  if (mapContainer) {
    micrositeMap.initialize();
  }
})();
